export default {
  fontSize: {
    root: 16, // 1rem
    h1: 65,
    h2: 50,
    h3: 36,
    h4: 32,
    h5: 28,
    h6: 24,
    h7: 22,
    subtitle1: 18,
    subtitle2: 16,
    body1: 16,
    body2: 14,
    body3: 14,
    buttonLarge: 18,
    buttonMedium: 14,
    buttonSmall: 13,
    buttonNav: 13,
    xsmall: 10,
    small: 13,
    medium: 14,
    base: 15,
    large: 18,
    xlarge: 36,
    xxlarge: 48
  },
  fontWeight: {
    light: 300,
    regular: 400,
    semibold: 600,
    bold: 700
  },
  lineHeight: {
    root: 16, // 1rem
    h1: 78,
    h2: 60,
    h3: 48,
    h4: 42,
    h5: 36,
    h6: 30,
    h7: 28,
    subtitle1: 24,
    subtitle2: 22,
    body1: 22,
    body2: 20,
    body3: 20,
    buttonLarge: 18,
    buttonMedium: 14,
    buttonSmall: 13,
    buttonNav: 18
  },
  letterSpacing: {
    h1: 0.25,
    h2: 0.25,
    h3: 0.2,
    h4: 0.2,
    h5: 0.2,
    h6: 0.2,
    h7: 0.2,
    subtitle1: 0.2,
    subtitle2: 0.2,
    body1: 0.15,
    body2: 0.2,
    body3: 0.15,
    buttonLarge: 0.2,
    buttonMedium: 0.15,
    buttonSmall: 0.15,
    buttonNav: 0.2
  }
};
